import React from 'react';
import PropTypes from 'prop-types';

import AccountListItem from './AccountListItem';

const AccountListItems = ({
  handleSelection,
  items,
  selectedItems,
  isSelectedBox,
  selectedUser,
}) => {
  const renderList = () =>
    items.map(item => {
      item.selected = selectedItems && selectedItems.indexOf(item.id) !== -1;
      return (
        <AccountListItem
          key={item.id}
          {...item}
          handleSelection={handleSelection}
          isSelectedBox={isSelectedBox}
          selectedUser={selectedUser}
        />
      );
    });

  return (
    <div className="multi-select-list">
      <ul
        className="vertical dropdown menu user-select-none accounts-multi-select-menu"
        data-dropdown-menu
      >
        {renderList()}
      </ul>
    </div>
  );
};

AccountListItems.propTypes = {
  handleSelection: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.object),
  selectedItems: PropTypes.instanceOf(Array),
  isSelectedBox: PropTypes.bool,
  selectedUser: PropTypes.instanceOf(Array),
};

export default AccountListItems;
